import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router, private location: Location) {}

  // Navegación interna
  goToCurriculum(): void {
    this.router.navigate(['/curriculum']);
  }

  goToCurriculumUpload(): void {
    this.router.navigate(['/curriculum/curriculum-upload']);
  }

  goToCurriculumSearch(): void {
    this.router.navigate(['/curriculum/curriculum-search']);
  }

  goToCurriculumDetail(): void {
    this.router.navigate(['/curriculum/curriculum-detail']);
  }

  goToJobOffers(): void {
    this.router.navigate(['/job-offers']);
  }

  goToJobOffersUpload(): void {
    this.router.navigate(['/job-offers/job-offers-upload']);
  }

  goToJobOffersSearch(): void {
    this.router.navigate(['/job-offers/job-offers-search']);
  }

  goToJobseekerSearch(): void {
    this.router.navigate(['/jobseeker/jobseeker-search']);
  }

  goToCurriculumSearchByCV(): void {
    this.router.navigate(['/curriculum/job-offers-search-by-cv']);
  }

  goToManagement(): void {
    this.router.navigate(['/management']);
  }

  goToManagementUsers(): void {
    this.router.navigate(['/management/users-search']);
  }

  goToAccesibilidad(): void {
    this.router.navigate(['/accesibilidad']);
  }

  goToMapaWeb(): void {
    this.router.navigate(['/mapa-web']);
  }

  // Volver a la página anterior
  goBack(): void {
    this.location.back();
  }
}
